import type { Locale } from '../domain/tools/types';

const localeTag = (locale: Locale): string => (locale === 'ar' ? 'ar-BH' : 'en-GB');

export function formatBytes(bytes: number, locale: Locale, precision = 1): string {
  if (!Number.isFinite(bytes) || bytes <= 0) return `0 ${locale === 'ar' ? 'بايت' : 'B'}`;
  const units = locale === 'ar' ? ['بايت', 'ك.ب', 'م.ب', 'ج.ب', 'ت.ب'] : ['B', 'KB', 'MB', 'GB', 'TB'];
  const index = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
  const value = bytes / 1024 ** index;
  return `${new Intl.NumberFormat(localeTag(locale), { maximumFractionDigits: index === 0 ? 0 : precision }).format(value)} ${units[index]}`;
}

export function formatNumber(value: number, locale: Locale, options?: Intl.NumberFormatOptions): string {
  return new Intl.NumberFormat(localeTag(locale), options).format(value);
}

export function formatPercent(value: number, locale: Locale): string {
  return new Intl.NumberFormat(localeTag(locale), { style: 'percent', maximumFractionDigits: 1 }).format(value);
}

export function formatDate(value: Date | number, locale: Locale): string {
  return new Intl.DateTimeFormat(localeTag(locale), { dateStyle: 'medium', timeStyle: 'short' }).format(value);
}
